/* Header Vehicle Quick-Nav — INDEX mode ("live" data_source).
 *
 * Same UI/UX as the menu-based header-vehicle-nav.js (3-level cascade, collapsed
 * summary, localStorage persistence, auto-navigate), aber die Auswahl-Optionen kommen
 * aus einem SAUBEREN, generierten Fahrzeug-Index (assets/fahrzeuge.json, aus dem
 * Live-Baseline via tools/restructure/build_fahrzeuge_index.py). Dadurch KEINE
 * Cross-Marken-/Cross-Modell-Kontamination (anders als bei den Live-Facetten).
 *
 * Der Index wird einmal geladen (data-hvn-index), Cascade-Schritte in-memory beantwortet.
 * Das FILTERN/NAVIGIEREN laeuft weiter live ueber die Storefront-Filter:
 *   mit Typ:  /collections/all?filter.p.m.fahrzeug.marke=VW&filter.p.m.fahrzeug.fahrzeugtyp=Golf+4
 *   Fallback: /collections/all?filter.p.m.fahrzeug.marke=VW&filter.p.m.fahrzeug.modell=Golf
 * -> neue Produkte mit vorhandenen Marke/Modell/Typ sind SOFORT findbar, ohne Regen.
 * Nur komplett neue Modelle brauchen einen neuen Index-Lauf (an den taegl. Fitment-Agent haengen).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cr-vehicle-v1';

  function init(root) {
    var cfg = {
      base: root.getAttribute('data-hvn-base') || '/collections/all',
      indexUrl: root.getAttribute('data-hvn-index') || '',
      section: root.getAttribute('data-hvn-section') || 'vehicle-index',
      keyMarke: root.getAttribute('data-hvn-key-marke') || 'filter.p.m.custom.marke',
      keyModell: root.getAttribute('data-hvn-key-modell') || 'filter.p.m.custom.modell',
      keyTyp: root.getAttribute('data-hvn-key-typ') || 'filter.p.m.custom.fahrzeugtyp'
    };

    var l1 = root.querySelector('[data-hvn-level="1"]');
    var l2 = root.querySelector('[data-hvn-level="2"]');
    var l3 = root.querySelector('[data-hvn-level="3"]');
    var submit = root.querySelector('[data-hvn-submit]');
    var summary = root.querySelector('[data-hvn-summary]');
    var summaryText = root.querySelector('[data-hvn-summary-text]') || summary;
    var editBtn = root.querySelector('[data-hvn-edit]');
    if (!l1 || !l2 || !l3 || !submit || !summary || !editBtn) return;

    var placeholders = {
      1: l1.getAttribute('data-placeholder') || '–',
      2: l2.getAttribute('data-placeholder') || '–',
      3: l3.getAttribute('data-placeholder') || '–'
    };

    // Current selected metafield VALUES (not indices — values are stable across renders)
    var sel = { marke: '', modell: '', typ: '' };
    // Latest known typen list for the current marke+modell (to decide fallback navigation)
    var currentTypen = [];
    // True when the chosen marke exposes no modell facet at all (e.g. brand tagged
    // only at marke level). Such a marke is a leaf → navigate at marke level.
    var markeHasNoModelle = false;
    var aborter = null;
    // Monotonic token guarding against stale async resolutions. Every cascade load
    // captures the current value; if a newer load has run by the time an older
    // request (or a synchronous cache hit) resolves, the stale result is discarded
    // before it can fill the wrong list or auto-navigate to the wrong vehicle.
    var reqSeq = 0;

    /* ---------- small DOM helpers ---------- */

    function makeOpt(label, value) {
      var o = document.createElement('option');
      o.textContent = label;
      o.value = value == null ? '' : value;
      return o;
    }

    function resetSelect(elt, placeholder, disabled) {
      elt.innerHTML = '';
      var p = makeOpt(placeholder, '');
      p.disabled = true;
      p.selected = true;
      elt.appendChild(p);
      elt.disabled = !!disabled;
    }

    function fillSelect(elt, items, placeholder, selectedValue) {
      resetSelect(elt, placeholder, false);
      items.forEach(function (item) {
        var opt = makeOpt(item.v, item.v);
        if (selectedValue != null && item.v === selectedValue) opt.selected = true;
        elt.appendChild(opt);
      });
      if (selectedValue) elt.value = selectedValue;
    }

    function setLoading(elt, on) {
      elt.classList.toggle('hvn__select--loading', !!on);
      elt.setAttribute('aria-busy', on ? 'true' : 'false');
      elt.disabled = !!on;
    }

    /* ---------- data layer (Section Rendering API + cache) ---------- */

    // ---------- Daten-Schicht: statischer, sauberer Index (assets/fahrzeuge.json) ----------
    // Der Index (aus dem Live-Baseline generiert, keine Cross-Marken/-Modell-Kontamination)
    // wird EINMAL geladen; alle Cascade-Schritte werden in-memory beantwortet.
    // Das FILTERN laeuft weiter live ueber die Storefront-Filter (targetUrl) -> neue Produkte
    // mit vorhandenen Marke/Modell/Typ sind sofort findbar, ohne Index-Regenerierung.
    var INDEX = null;
    var indexReady = null;

    function loadIndexOnce() {
      if (indexReady) return indexReady;
      var url = cfg.indexUrl;
      if (!url) { indexReady = Promise.resolve({ marken: {}, order: [] }); return indexReady; }
      indexReady = fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (data) {
          INDEX = { marken: {}, order: [] };
          (data.marken || []).forEach(function (m) {
            var modelle = {}, morder = [];
            (m.modelle || []).forEach(function (mo) {
              // typen sind jetzt Objekte {typ,url}; url pro Knoten = konkreteste Collection.
              modelle[mo.modell] = { url: mo.url || '', typen: (mo.typen || []) };
              morder.push(mo.modell);
            });
            INDEX.marken[m.marke] = { url: m.url || '', modelle: modelle, order: morder };
            INDEX.order.push(m.marke);
          });
          return INDEX;
        })
        .catch(function (err) {
          console.warn('[hvn] Fahrzeug-Index konnte nicht geladen werden:', err);
          INDEX = { marken: {}, order: [] };
          return INDEX;
        });
      return indexReady;
    }

    // Rueckgabeform wie zuvor: {marke:[{v}],modell:[{v}],fahrzeugtyp:[{v}]} (im Index vorsortiert).
    function fetchIndex(filters) {
      return loadIndexOnce().then(function (ix) {
        var out = { marke: [], modell: [], fahrzeugtyp: [] };
        if (!filters.marke) {
          out.marke = ix.order.map(function (v) { return { v: v }; });
          return out;
        }
        var m = ix.marken[filters.marke];
        if (!m) return out;
        if (!filters.modell) {
          out.modell = m.order.map(function (v) { return { v: v }; });
          return out;
        }
        var mo = m.modelle[filters.modell];
        ((mo && mo.typen) || []).forEach(function (t) { out.fahrzeugtyp.push({ v: t.typ }); });
        return out;
      });
    }

    // Gebackene Ziel-URL aus dem Index (konkreteste Collection + ggf. Facette).
    // Leerstring, wenn (noch) nicht aufloesbar -> targetUrl faellt auf Facetten zurueck.
    function bakedUrl() {
      if (!INDEX || !sel.marke) return '';
      var m = INDEX.marken[sel.marke];
      if (!m) return '';
      if (sel.modell) {
        var mo = m.modelle[sel.modell];
        if (mo) {
          if (sel.typ) {
            for (var i = 0; i < mo.typen.length; i++) {
              if (mo.typen[i].typ === sel.typ) return mo.typen[i].url || '';
            }
          }
          return mo.url || '';
        }
      }
      return m.url || '';
    }

    /* ---------- label / persistence ---------- */

    function trimPrefix(child, parent) {
      if (!child || !parent) return child || '';
      var c = String(child).trim();
      var p = String(parent).trim();
      if (c.length > p.length && c.toLowerCase().indexOf(p.toLowerCase()) === 0) {
        var rest = c.slice(p.length).trim();
        if (rest) return rest;
      }
      return c;
    }

    function buildLabel() {
      var parts = [sel.marke];
      if (sel.modell) parts.push(sel.modell);
      if (sel.typ) parts.push(trimPrefix(sel.typ, sel.modell));
      return parts.join(' · ');
    }

    function targetUrl() {
      if (!sel.marke) return null;
      // Bevorzugt die konkreteste vorhandene Fahrzeug-Collection (aus dem Index) statt
      // /collections/all -> Auswahl landet im richtigen Kontext (Marke/Modell/Chassis).
      var baked = bakedUrl();
      if (baked) return baked;
      // Fallback (Index-URL fehlt/veraltet): Storefront-Facetten wie zuvor.
      var params = new URLSearchParams();
      params.set(cfg.keyMarke, sel.marke);
      if (sel.typ) {
        params.set(cfg.keyTyp, sel.typ);
      } else if (sel.modell) {
        params.set(cfg.keyModell, sel.modell);
      }
      // else: marke-only target (brand is a leaf with no modell facet)
      return cfg.base + '?' + params.toString();
    }

    function saveSelection(label, url) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          marke: sel.marke, modell: sel.modell, typ: sel.typ, label: label, url: url
        }));
      } catch (_) {}
    }

    function loadSelection() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (_) { return null; }
    }

    function clearSelection() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    }

    /* ---------- view state ---------- */

    function setCollapsed(label) {
      summaryText.textContent = label;
      summary.hidden = false;
      editBtn.hidden = false;
      root.setAttribute('data-hvn-collapsed', '');
    }

    function setExpanded() {
      summary.hidden = true;
      editBtn.hidden = true;
      root.removeAttribute('data-hvn-collapsed');
    }

    // A navigable selection =
    //   marke + Typ (most precise), OR
    //   marke + any Modell — a model is ALWAYS navigable so the user can always
    //     "show all of this model" (e.g. BMW 3er → all 3er); a Typ, when the
    //     model has them, is an optional refinement that auto-navigates on pick.
    //     This keeps "Golf 4 bleibt Golf 4" while never stranding models that
    //     do expose Typen behind a disabled button, OR
    //   marke alone when the brand exposes no Modell facet (brand-leaf).
    function isNavigable() {
      if (!sel.marke) return false;
      if (sel.typ) return true;
      if (sel.modell) return true;
      if (!sel.modell && markeHasNoModelle) return true;
      return false;
    }

    function updateSubmit() {
      submit.disabled = !isNavigable();
    }

    function commit() {
      var url = targetUrl();
      if (!url) return;
      var label = buildLabel();
      saveSelection(label, url);
      setCollapsed(label);
      window.location.href = url;
    }

    /* ---------- cascade ---------- */

    // Each loader returns a Promise. loadMarken/loadModelle resolve to a boolean
    // `applied` (false = superseded by a newer load, caller must not auto-commit).
    // loadTypen resolves to the typen array, or null when superseded.

    function loadMarken(preselect) {
      var myReq = ++reqSeq;
      setLoading(l1, true);
      resetSelect(l2, placeholders[2], true);
      resetSelect(l3, placeholders[3], true);
      return fetchIndex({}).then(function (data) {
        if (myReq !== reqSeq) return false;
        if (!data.marke.length) {
          // No facet data — hide the finder rather than show an empty, broken bar.
          root.setAttribute('hidden', '');
          return false;
        }
        fillSelect(l1, data.marke, placeholders[1], preselect || null);
        setLoading(l1, false);
        return true;
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return false;
        if (myReq !== reqSeq) return false;
        setLoading(l1, false);
        l1.disabled = false;
        console.warn('[hvn] Marken konnten nicht geladen werden:', err);
        return false;
      });
    }

    function loadModelle(preselect) {
      var myReq = ++reqSeq;
      setLoading(l2, true);
      resetSelect(l3, placeholders[3], true);
      currentTypen = [];
      markeHasNoModelle = false;
      return fetchIndex({ marke: sel.marke }).then(function (data) {
        if (myReq !== reqSeq) return false;
        if (!data.modell.length) {
          // Brand-leaf: no models to choose. Navigate at marke level so the
          // user is never stranded on an empty, dead-end control.
          markeHasNoModelle = true;
          resetSelect(l2, placeholders[2], true);
          setLoading(l2, false);
          updateSubmit();
          return true;
        }
        markeHasNoModelle = false;
        fillSelect(l2, data.modell, placeholders[2], preselect || null);
        setLoading(l2, false);
        updateSubmit();
        return true;
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return false;
        if (myReq !== reqSeq) return false;
        setLoading(l2, false);
        console.warn('[hvn] Modelle konnten nicht geladen werden:', err);
        return false;
      });
    }

    function loadTypen(preselect) {
      var myReq = ++reqSeq;
      setLoading(l3, true);
      return fetchIndex({ marke: sel.marke, modell: sel.modell }).then(function (data) {
        if (myReq !== reqSeq) return null;
        currentTypen = data.fahrzeugtyp || [];
        if (currentTypen.length > 0) {
          fillSelect(l3, currentTypen, placeholders[3], preselect || null);
          setLoading(l3, false);
        } else {
          resetSelect(l3, placeholders[3], true);
        }
        updateSubmit();
        return currentTypen;
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return null;
        if (myReq !== reqSeq) return null;
        setLoading(l3, false);
        currentTypen = [];
        updateSubmit();
        console.warn('[hvn] Typen konnten nicht geladen werden:', err);
        return [];
      });
    }

    /* ---------- events ---------- */

    l1.addEventListener('change', function () {
      sel.marke = l1.value;
      sel.modell = '';
      sel.typ = '';
      currentTypen = [];
      markeHasNoModelle = false;
      updateSubmit();
      if (sel.marke) loadModelle().then(function (applied) {
        // Brand with no models is a leaf → go straight to the brand collection.
        if (applied && markeHasNoModelle && isNavigable()) commit();
      });
    });

    l2.addEventListener('change', function () {
      sel.modell = l2.value;
      sel.typ = '';
      updateSubmit();
      if (!sel.modell) return;
      loadTypen().then(function (typen) {
        // null = superseded by a newer selection; do not auto-navigate.
        if (typen === null) return;
        // "Golf 4 bleibt Golf 4": a model without its own Typ navigates at model level.
        if (typen.length === 0 && isNavigable()) commit();
      });
    });

    l3.addEventListener('change', function () {
      sel.typ = l3.value;
      updateSubmit();
      if (isNavigable()) commit();
    });

    submit.addEventListener('click', function () {
      if (isNavigable()) commit();
    });
    root.addEventListener('submit', function (e) { e.preventDefault(); if (isNavigable()) commit(); });

    function startFresh() {
      sel = { marke: '', modell: '', typ: '' };
      currentTypen = [];
      markeHasNoModelle = false;
      setExpanded();
      updateSubmit();
      loadMarken();
    }

    function reset() {
      clearSelection();
      startFresh();
    }

    // Re-open the form pre-filled from a saved selection (validates against live data).
    function editFromSaved(saved) {
      setExpanded();
      sel = { marke: saved.marke || '', modell: saved.modell || '', typ: saved.typ || '' };
      loadMarken(sel.marke).then(function () {
        if (!sel.marke) return;
        // Confirm the saved marke still exists in the live list.
        if (l1.value !== sel.marke) { reset(); return; }
        return loadModelle(sel.modell);
      }).then(function () {
        if (!sel.modell) return;
        if (l2.value !== sel.modell) { sel.modell = ''; sel.typ = ''; updateSubmit(); return; }
        return loadTypen(sel.typ);
      }).then(function () {
        updateSubmit();
      });
    }

    editBtn.addEventListener('click', function () {
      var saved = loadSelection();
      if (saved && saved.marke) { editFromSaved(saved); } else { reset(); }
    });
    summary.addEventListener('click', function () {
      var saved = loadSelection();
      if (saved && saved.marke) { editFromSaved(saved); } else { reset(); }
    });

    /* ---------- boot ---------- */

    var saved = loadSelection();
    if (saved && saved.label && saved.url) {
      // Returning visitor: show their vehicle instantly, zero network requests.
      sel = { marke: saved.marke || '', modell: saved.modell || '', typ: saved.typ || '' };
      setCollapsed(saved.label);
    } else {
      startFresh();
    }
  }

  function boot() {
    document.querySelectorAll('[data-hvn-root][data-hvn-mode="live"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
